import Pqp from "../../../3x1010/Pqp";
import Bout from "../../bout/Bout";
import Game from "../../Game";

export default class Lore {
	constructor(mob, power, mobcfg) {
		this.mob = mob;
		this.power = power;
		this.mobcfg = mobcfg;
		let cls = mob.race;

		if (cls === "rat") {
			this.createRat(power);
		} else if (cls === "slime") {
			this.createSlime(power);
		} else if (cls === "bat") {
			this.createBat(power);
		} else if (cls === "goblin") {
			this.createGoblin(power);
		} else if (cls === "sniper") {
			this.createSniper(power);
		} else if (cls === "spider") {
			this.createSpider(power);
		} else if (cls === "orc") {
			this.createOrc(power);
		} else if (cls === "troll") {
			this.createTroll(power);
		}

	}



	static add(mob, power,mobcfg) {
		if (power.indexOf(" ") >= 0) {
			power = power.split(" ")[1];
		} else {
			power = "e";
		}
		mob.lore = new Lore(mob, power, mobcfg)
	}

	isDead() {
		if (this.hp === 0) {
			return true;
		}
		return false;
	}

	getBaseStatsForRace(race) {
		for (let x = 0; x < this.mobcfg.length; x++) {
			if (this.mobcfg[x].race === race) {
				return JSON.parse(JSON.stringify(this.mobcfg[x]));
			}
		}
	}

	addPowerToStats(power,stats) {
		//console.log(stats)
		stats.armour = parseInt(stats.armour);
		stats.hp = parseInt(stats.hp);
		stats.max_damage = parseInt(stats.max_damage);
		stats.min_damage = parseInt(stats.min_damage);
		stats.speed = parseInt(stats.speed);
		stats.xp = parseInt(stats.xp);
		stats.max_hp = stats.hp;
		let lev;
		// Analizza il power
		if (power.indexOf("w") >= 0) {
			// weaker
			lev = -parseInt(power.split("w")[1]);
			if (lev === "") {
				lev = -1;
			}
			stats = this.incrementDecremetStats(stats,lev);
		} else if (power.indexOf("s") >= 0) {
			// stronger
			lev = parseInt(power.split("s")[1]);
			if (lev === "") {
				lev = 1;
			}
			stats = this.incrementDecremetStats(stats, lev);
		} else {
			// equals 
			lev = 0;
		}
		// Nome
		if (power.indexOf("n") >= 0){
			// named
			stats.named = true;
			let tmp = stats.nameds.split(",")
			stats.name = jQuery.trim(tmp[Pqp.rnd(tmp.length - 1)]);
			let star = 0;
			if (lev > 1) {
				star = 1
			} else if (lev > 2) {
				star = 2
			} else if (lev > 3) {
				star = 3
			}
			stats.stars = star;
		} else {
			// normal name 
			stats.named = false;
			let index = 0;
			if (lev > 2) {
				index = 4;
			} else if (lev > 0) {
				index = 3;
			} else if (lev == 0) {
				index = 2;
			} else if (lev == -1) {
				index = 1;
			} else {
				index = 0;
			}
			let tmp = stats.names.split(",")
			stats.name = jQuery.trim(tmp[index]);
			stats.stars = 0;
		}

		stats.level = Bout.that.player.currentLevel + lev;

		//console.log(stats)
		return stats;

	}

	incrementDecremetStats(stats,lev) {
		stats.armour += 1 * lev;
		stats.hp += Math.floor(stats.hp * 0.1 * lev);
		stats.max_damage += 1 * lev;
		stats.min_damage += 1 * lev;
		stats.speed  += 1 * lev;
		stats.xp += Math.floor(stats.hp * 0.2 * lev);
		stats.max_hp = stats.hp;
		return stats;
	}

	setStats(stats) {
		for (var prop in stats) {
			this[prop] = stats[prop];
		}
	}


	createOrc(power) {
		let stats = this.getBaseStatsForRace("orc");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);
		

		/*this.name = "Orc Warrior";
		this.named = false;
		this.hp = 50;
		this.max_hp = 50;
		this.xp = 70;
		this.min_damage = 5;
		this.max_damage = 10;
		this.speed = 1;
		this.armour = 5;
		this.level = Bout.that.player.currentLevel;
		this.stars = 0;*/
	}

	createSlime(power) {
		let stats = this.getBaseStatsForRace("slime");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);

		/*this.name = "Jwilson";
		this.named = true;
		this.hp = 20;
		this.max_hp = 20;
		this.xp = 25;
		this.min_damage = 3;
		this.max_damage = 6;
		this.speed = 2;
		this.armour = 1;
		this.level = Bout.that.player.currentLevel + 4;
		this.stars = 2;*/
	}

	createRat(power) {
		let stats = this.getBaseStatsForRace("rat");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);
	}

	createBat(power) {
		let stats = this.getBaseStatsForRace("bat");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);
	}

	createGoblin(power) {
		let stats = this.getBaseStatsForRace("goblin");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);

	}

	createSniper(power) {
		let stats = this.getBaseStatsForRace("sniper");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);
	}

	createSpider(power) {
		let stats = this.getBaseStatsForRace("spider");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);
	}

	createTroll(power) {
		let stats = this.getBaseStatsForRace("troll");
		stats = this.addPowerToStats(power, stats)
		this.setStats(stats);

	}


}